import { MenuItem, Checkbox } from "@material-ui/core";
import CustomizedDialogs from "../../customModal";
import { Input } from "../../../forms/input";
import React, { useState, useEffect, useReducer } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  getNewPurchaseFundList,
  validateSubBroker,
  submitLumpsumDetails,
  clearingFirstTimeInvestorJourney,
  storeSchemeDetails,
  PurchaseSaveNominee
} from "../../../../store/actions";
import {
  GET_CATEGORY_LIST,
  GET_CATEGORY_LIST_SUCCESS,
  GET_CATEGORY_LIST_FAILED,
  REGULAR,
} from "../../../../store/types";
import IntegrationReactSelect from "../../../forms/autoCompleteInput";
import { RadioButton } from "./lib/Radiobutton";
import CustomLoader from "../../../forms/Loader";
import { format } from "date-fns";
import CustomizedSelect from "../customizedSelect";
import CardComponent from "./lib/CardComponent";
const Lumpsum = (props) => {
  const { state } = useLocation();
  const initialState = {
    Scheme: { value: "" },
    AMC: { value: "" },
    Category: { value: "" },
    Combo: false,
    comboDisclaimer: "",
    comboLabel: "",
    "Scheme Plan": "",
    "Scheme Option": "",
    Amount: { value: "" },
    "Sub Broker Code": { value: "" },
    Sub_ARN: { value: "" },
    planValue: "",
    optionValue: "",
    schemeValue: "",
    EUIN: "",
    schemeList: [],
    euinList: [],
    amcList: [],
    CategoryList: [],
    multiples: "",
    "EUIN NO": { value: "yes" },
    "BOB-PIO Payment Option": { value: "no" },
    "Payment (pre-debit) Reference Number": { value: "" },
  };
  const [formValues, setFormValues] = useReducer(
    (preValues, newValues) => ({ ...preValues, ...newValues }),
    initialState
  );
  const BOB = props.token === "ARN-35783" ? false : true;
  const InputFields = [
    [
      {
        name: "AMC",
        type: "select",
        placeholder: "Select AMC",
        isMandatory: true,
        listName: "amcList",
        disabled: true,
      },
      {
        name: "Category",
        type: "select",
        placeholder: "Select Category",
        isMandatory: true,
        listName: "CategoryList",
      },

      {
        name: "Scheme",
        type: "Searchselect",
        placeholder: "Select Scheme",
        isMandatory: true,
        listName: "schemeList",
      },
      {
        name: "Scheme Plan",
        type: "text",
        placeholder: "Select Scheme Plan",
        isMandatory: true,
        listName: "schemePlanList",
        disabled: true,
        display: "none",
      },
    ],
    [
      {
        name: "Sub_ARN",
        type: "number",
        placeholder: "Sub ARN Code",
        isMandatory: false,
      },
    ],
    [
      {
        name: "Scheme Option",
        type: "text",
        placeholder: "Select Scheme Option",
        isMandatory: true,
        listName: "schemeOptionList",
        disabled: true,
        display: "none",
      },
      {
        name: "EUIN NO",
        type: "paymentOption",
      },
      {
        name: "EUIN",
        type: "Searchselect",
        placeholder: "Select EUIN",
        isMandatory: formValues["EUIN NO"].value === "no" ? false : true,
        listName: "euinList",
        display: formValues["EUIN NO"].value === "no" ? true : false,
      },
    ],
    [
      {
        name: "Amount",
        type: "number",
        placeholder: "Enter Amount",
        isMandatory: true,
      },
    ],
    [
      {
        name: "Combo",
        type: "combo",
      },
    ],

    [
      {
        name: "BOB-PIO Payment Option",
        type: "paymentOption",
        display: BOB,
      },

      {
        name: "Payment (pre-debit) Reference Number",
        type: "text",
        placeholder: "Reference Number",
        isMandatory:
          formValues["BOB-PIO Payment Option"].value === "yes" ? false : true,
        display:
          formValues["BOB-PIO Payment Option"].value === "yes" ? false : true,
      },
    ],
  ];
  const [dialog, setDialog] = useState({ open: false, appno: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const history = useHistory();
  const { AMC } = formValues;
  const fund = AMC.value;
  const fetchAmcList = async () => {
    try {
      setIsLoading(true);
      const params = {
        opt: "A",
        schemetype: props.userId,
      };
      const response = await props.getNewPurchaseFundList(params);
      const { Dtinformation } = response;
      const amcList = Dtinformation.map((item) => ({
        value: item.amc_code,
        label: item.amc_name,
      }));
      setFormValues({ amcList, AMC: { value: props.applicantparams.fund } });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchSchemeList = async () => {
    try {
      const params = {
        plntype: "Regular",
        opt: "S",
        schemetype: formValues.Category.value,
        fund: formValues.AMC.value,
      };
      const response = await props.getNewPurchaseFundList(params);
      const { Dtinformation } = response;
      const schemeList = Dtinformation.map((item) => ({
        value: item.Scheme_Plan,
        label: item.Scheme_Desc,
        plan: item.PlanDesc,
        option: item.fm_optiondesc,
        planValue: item.Scheme_Plan.split("~")[2],
        optionValue: item.Scheme_Plan.split("~")[3],
        schemeValue: item.Scheme_Plan.split("~")[1],
        minAmt: item.MinAmt,
        multiples: item.multiples,
        combo: item.combo_flag,
        comboDisclaimer: item.combo_disclaimer,
        comboLabel: item.combo_lable,
      }));
      setFormValues({
        schemeList,
      });
    } catch (e) {
      setFormValues({ schemeList: [] });
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchEuinList = async () => {
    try {
      setIsLoading(true);
      if (!!fund) {
        const response = await props.validateSubBroker({
          Fund: fund,
          SubAgentCd: `ARN-${formValues?.Sub_ARN?.value.trim() || ""}`,
          AgentCd: props.token,
        });
        const { DtData } = response;
        const euinList = DtData.map((item) => ({
          value: item.abm_name,
          label: item.abm_agent,
        }));
        if (euinList.length === 1) {
          setFormValues({
            EUIN: {
              value: { label: euinList[0].label, value: euinList[0].value },
            },
          });
        }
        setFormValues({ euinList: euinList });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchCategoryList = async () => {
    try {
      setIsLoading(true);
      let params = { plntype: REGULAR };
      params = { ...params, opt: "AT", fund: fund };
      const types = [
        GET_CATEGORY_LIST,
        GET_CATEGORY_LIST_SUCCESS,
        GET_CATEGORY_LIST_FAILED,
      ];
      const response = await props.getNewPurchaseFundList(params, types);
      const { Dtinformation } = response;
      const categoryList = Dtinformation.map((item) => ({
        value: item.fm_subcategory,
        label: item.fm_subcategory,
      }));
      setFormValues({ CategoryList: categoryList });
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchAmcList();
  }, []);
  useEffect(() => {
    (async function () {
      if (!!fund) {
        await fetchSchemeList();
        await fetchEuinList();
      }
    })();
  }, [formValues.Category.value]);
  useEffect(() => {
    fetchCategoryList();
  }, [fund]);
  const handleScheme = (label) => (event) => {
    const { schemeList } = formValues;
    if (label === "Scheme") {
      const scheme = schemeList.find((item) => item.value === event.value);
      const commonValues = {
        Scheme: { value: event },
        "Scheme Plan": { value: scheme.plan },
        "Scheme Option": { value: scheme.option },
        planValue: scheme.planValue,
        optionValue: scheme.optionValue,
        schemeValue: scheme.schemeValue,
        minimumAmount: scheme.minAmt,
        multiples: scheme.multiples || 1,
      };

      setFormValues({
        ...commonValues,
        ...(scheme.combo === "Y" && !!scheme.comboDisclaimer
          ? { Combo: true, comboDisclaimer: scheme.comboDisclaimer,comboLabel:scheme.comboLabel }
          : { Combo:false, comboDisclaimer: "",comboLabel:"" }),
      });
    }
    if (label === "EUIN") {
      setFormValues({
        EUIN: { value: event },
      });
    }
  };
  const handleBlur = () => {
    fetchEuinList();
  };

  const handleChange = (label) => (event) => {
    const value = label !== "Scheme" ? event.target.value : event.value;
    switch (label) {
      case "AMC":
        setFormValues({
          [label]: { value },
          Scheme: { value: "" },
          Category: { value: "" },
          "Scheme Plan": "",
          "Scheme Option": "",
          Amount: { value: "" },
        });
        break;
      case "Category":
        setFormValues({
          [label]: { value },
          Scheme: { value: "" },
          "Scheme Plan": "",
          "Scheme Option": "",
          Amount: { value: "" },
        });
        break;
      case "Combo":
        setFormValues({
          Combo: !formValues.Combo,
        });
        break;

      case "Amount":
        if (parseInt(value) < parseInt(formValues.minimumAmount)) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                " Amount should be greater than or equal to " +
                formValues.minimumAmount,
            },
          });
        } else if (parseInt(value) % parseInt(formValues.multiples) !== 0) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                "Amount should be multiple of " + formValues.multiples,
            },
          });
        } else {
          setFormValues({ [label]: { value } });
        }
        break;
      default:
        setFormValues({ [label]: { value } });
    }
  };
  const closeModel = () => {
    history.replace("/new-transaction");
  };
  const gotoTransactionTypes = () => {
    if (props.tran_enable_flag === "Y") {
      history.replace("/new-transaction");
    } else {
      history.replace("/");
    }
  };

  const dispatch = useDispatch();
  const submit = async () => {
    if (!formValues.Scheme.value) {
      setFormValues({
        Scheme: {
          value: "",
          isError: true,
          errorMessage: " Scheme is Mandatory",
        },
      });
      return;
    } else if (!formValues.EUIN.value && formValues["EUIN"].value === "yes") {
    } else if (
      !formValues.EUIN.value &&
      formValues["EUIN NO"].value === "yes"
    ) {
      setFormValues({
        EUIN: {
          value: "",
          isError: true,
          errorMessage: "EUIN is Mandatory",
        },
      });
      return;
    } else if (
      formValues["BOB-PIO Payment Option"].value === "yes" &&
      !/^[sS]\d{8}$/.test(
        formValues["Payment (pre-debit) Reference Number"].value
      )
    ) {
      setFormValues({
        "Payment (pre-debit) Reference Number": {
          value: "",
          isError: true,
          errorMessage: "Enter a valid reference number*",
        },
      });
      return;
    } else if (!isChecked) {
      alert("Please accept the terms and conditions to proceed");
      return;
    } else if (formValues.Amount.value < formValues.minimumAmount) {
      setFormValues({
        Amount: {
          value: formValues.Amount.value,
          isError: true,
          errorMessage:
            " Amount should be greater than or equal to " +
            formValues.minimumAmount,
        },
      });
      return;
    } else if (formValues.Amount.value % formValues.multiples !== 0) {
      setFormValues({
        Amount: {
          value: formValues.Amount.value,
          isError: true,
          errorMessage:
            "Amount should be a multiple of " + formValues.multiples,
        },
      });
      return;
    } else {
      if (!!formValues.Combo) {
        if (
          window.confirm(
            "You have opted to do a Purchase cum Switch. Do you want to proceed?"
          )
        ) {
        } else {
          return;
        }
      }
      setIsLoading(true);
      try {
        const response = await props.PurchaseSaveNominee({ ...props.nomineDetails.payload ? props.nomineDetails.payload : {} });
    
        if (!!response?.Dtinformation[0]?.nom_id || response?.Dtinformation[0]?.nom_id===null) {
          const { amcList } = formValues;
          const amc = amcList.find((item) => item.value === fund);
      
          const schemedetails = {
            IWishToNominate:props?.nomineDetails?.payload?.IWishToNominate,
            i_fund: fund,
            i_scheme: formValues.schemeValue,
            i_plan: formValues.planValue,
            i_option: formValues.optionValue,
            i_EUINno:
              formValues["EUIN NO"].value === "no" ? "" : formValues.EUIN?.value?.value,
            i_amount: formValues.Amount.value,
            i_subarncode: !!formValues.Sub_ARN.value ? `ARN-${formValues.Sub_ARN.value}` : "",
            i_disitributorid: props.token,
            combo_flag: !!formValues.Combo ? "Y" : "N",
          };
      
          props.storeSchemeDetails({
            ...formValues,
            type: "lumpsum",
            ct: formValues.Category.value,
          });
      
          const paramsLumpsum = {
            ...props.applicantparams,
            ...props.fatcaDetails,
            ...props.investmentparams,
            ...schemedetails,
            ...props?.nomineDetails?.dotnetApiSubmitKeys,
            Nomslno:response.Dtinformation[0]?.nom_id,
            i_trtype: "NEW",
            i_appldt: format(new Date(), "MM/dd/yyyy"),
            i_chqdt: format(new Date(), "MM/dd/yyyy"),
            i_entby: props.userId,
            i_bankadd2: " -",
            i_bankadd3: " -",
            Invdistflag: "W",
          };
      
          try {
            const responseLumpsum = await props.submitLumpsumDetails(paramsLumpsum);

            if (responseLumpsum.error) {
              alert(responseLumpsum.error);
              return;
            }

            const { DtData } = responseLumpsum;

            if (!DtData || !DtData[0] || !DtData[0].appno) {
              alert("Unexpected response");
              return;
            }

            const { appno } = DtData[0];

            dispatch(clearingFirstTimeInvestorJourney());
            setDialog({ appno: appno, open: true });
          } catch (err) {
            alert(err);
          } finally {
            setIsLoading(false);
          }
        } else {
          alert("Nominee ID is missing. Please check the nominee details.");
          setIsLoading(false);
        }
      } catch (err) {
        alert("An error occurred while saving nominee details. Please try again.");
        setIsLoading(false);
      }
    }
  };
  const handleCombo = ()=>{
    setFormValues({
      Combo:  !formValues.Combo,
    });
  }
  return (
    <>
      <CustomLoader display={isLoading} />
      <CardComponent title="Scheme Details">
        <></>
        {InputFields.map((section, index) => (
          <div key={index}>
            {section.map((field) => (
              <div
                className="input-margin-investor-flow appbar-div dual-margin"
                key={field.name}
                style={{
                  display: field.display ? "none" : "",
                }}
              >
                {field.type === "select" ? (
                  <CustomizedSelect
                    name={field.name}
                    isMandatory={field.isMandatory}
                    value={formValues[field.name].value}
                    isError={formValues[field.name].isError}
                    errorMessage={formValues[field.name].errorMessage}
                    handleChange={handleChange(field.name)}
                    placeholder={`Select ${field.name}`}
                    id={`${field.name}Field`}
                    disabled={field.disabled}
                  >
                    {formValues[field.listName].map((i, index) => (
                      <MenuItem value={i.value} key={index}>
                        {i.label}
                      </MenuItem>
                    ))}
                  </CustomizedSelect>
                ) : field.type === "paymentOption" ? (
                  <>
                    <RadioButton
                      value={formValues[field.name].value}
                      Heading={field.name === "EUIN NO" ? "EUIN" : field.name}
                      onChange={handleChange(field.name)}
                    />
                    <>
                      {formValues["EUIN NO"].value === "no" && (
                        <span className="euin-text">
                          {" "}
                          I/We hereby confirm that the EUIN box has been
                          intentionally left the blank by me/us as this is an
                          'execution-only' transaction without any interaction
                          or advice by any personnel of the above distributor or
                          notwithstanding the advice of in-appropriateness,if
                          any provided by any personnel of the distributor and
                          the distributor has not charged any advisory fees on
                          this transaction
                        </span>
                      )}
                    </>
                  </>
                ) : field.type === "Searchselect" ? (
                  <>
                    <div className="goal-amount">
                      <div className="input-name input-integrated-label">
                        {field.name === "Scheme" ? "Scheme" : ""}
                      </div>
                      <IntegrationReactSelect
                        suggestions={formValues[field.listName].map((i) => ({
                          label: i.label,
                          value: i.value,
                        }))}
                        value={formValues[field.name].value}
                        placeholder={`Select ${field.name}`}
                        handleChange={handleScheme(field.name)}
                        disabled={field.disabled}
                        isError={formValues[field.name].isError}
                        errorMessage={formValues[field.name].errorMessage}
                      />
                    </div>
                  </>
                ) : field.type === "combo" ? (
                  <div>
                    {!!formValues.comboDisclaimer && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Checkbox
                          onClick={handleCombo}
                          checked={!!formValues.Combo}
                        />
                        <div
                          style={{
                            fontFamily: "OpenSans-SemiBold",
                            fontSize: 14,
                          }}
                        >
                          {formValues.comboLabel}
                        </div>
                      </div>
                    )}
                    {!!formValues.comboDisclaimer && (
                      <div
                        style={{
                          color: "#283d7c",
                          fontSize: 14,
                          fontFamily: "OpenSans-SemiBold",
                          margin: 10,
                        }}
                      >
                        {" "}
                        {formValues.comboDisclaimer}
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    <div className="goal-amount">
                      <Input
                        name={
                          field.name == "Sub_ARN" ? "Sub ARN Code" : field.name
                        }
                        isMandatory={field.isMandatory}
                        type={field.type}
                        value={formValues[field.name].value}
                        onChange={handleChange(field.name)}
                        onBlur={
                          field.name == "Sub_ARN"
                            ? handleBlur
                            : handleChange(field.name)
                        }
                        isError={formValues[field.name].isError}
                        isShowError={formValues[field.name].isError}
                        errorMessage={formValues[field.name].errorMessage}
                        id={`${field.name}Field`}
                        disabled={field.disabled}
                      />
                    </div>
                    {field.name === "Amount" && (
                      <span>Minimum Amount : ₹ {formValues.minimumAmount}</span>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
        ))}
        <>
          <Checkbox
            onChange={() => setIsChecked((p) => !p)}
            checked={isChecked}
          />
          <span style={{ fontWeight: 500 }}>
            I/We have read and understood the contents of the Offer Document(s),
            Load Structure(s) of the respective Scheme(s) and agree to abide by
            the terms, conditions, rules and regulations of the respective
            Scheme(s).
          </span>
        </>
        <p style={{ fontWeight: 500, marginTop: "10px" }}>
          The ARN holder has disclosed to me/us all the commissions in the form
          of trail commission or any other mode), payable to him for the
          different competing Schemes of various Mutual Funds from amongst which
          the Scheme is being recommended to me/us.
        </p>
        <p style={{ fontWeight: 500, marginTop: "10px" }}>
          Disclaimer: The Registrar of the AMC will allot the number of units
          for the total investment amount. The number of Units allotted by the
          Registrar will reflect in your online account statement within 2
          working days.
        </p>
      </CardComponent>
      <div className="d-flex align-items-center container-margin ">
        <button
             className="new-investor-button new-investor-active rounded ml-auto text-uppercase m-0 mr-0"
             style={{ filter: "grayscale(1) opacity(0.4)" }}
          onClick={() =>
            history.replace("/new-investor-transaction/bank-details", state)
          }
        >
          BACK
        </button>
        <button
          className="new-investor-button new-investor-active"
          onClick={submit}
        >
          SUBMIT
        </button>
        <CustomizedDialogs
          open={dialog.open}
          refNo={dialog.appno}
          transactName={"Lumpsum"}
          closeModal={gotoTransactionTypes}
          Transaction={true}
          transactionStatus={closeModel}
        />
      </div>
    </>
  );
};
export default connect(
  ({ authReducer, transactions, newinvestor }) => {
    const { token, userId, tran_enable_flag } = authReducer;
    const { euinList } = transactions;
    const {
      schemeDetails,
      fatcaDetails,
      applicantparams,
      investmentparams,
      nomineDetails,
    } = newinvestor;
    return {
      schemeDetails,
      tran_enable_flag,
      token,
      userId,
      euinList,
      fatcaDetails,
      applicantparams,
      investmentparams,
      nomineDetails,
    };
  },
  {
    getNewPurchaseFundList,
    validateSubBroker,
    submitLumpsumDetails,
    storeSchemeDetails,
    clearingFirstTimeInvestorJourney,
    PurchaseSaveNominee
  }
)(Lumpsum);
